import extend from 'extend';
import Q from 'q';
import _ from 'underscore';
import to_string from "nllib/src/convert/to_string";
import wait_some_seconds from "nllib/src/common/wait_some_seconds";

export default {
    mixins: [],

    props: {
        value: {
            type: Array,
            required: false,
            default: null,
        },

        enableAutoInit: {
            type: Boolean,
            required: false,
            default: true,
        },
    },

    data() {
        return {
            value_for_v_model: [],
            temp_value_for_v_model: [],

            data_get_data_source: {
                defer: Q.defer(),
                all_entity_list: [],
            },

            left_card: {
                loading: false,
            },

            left_input: {
                value: ``,
            },

            right_card: {
                loading: false,
            },

            right_input: {
                value: ``,
            },

            init_parameter: {

                // 场景：
                // 000:value_for_v_model和temp_value_for_v_model的值同步，即在ui上马上选，value_for_v_model的值马上变化
                // 100:value_for_v_model和temp_value_for_v_model的值不同步，即要还需要一个操作将value_for_v_model赋值为temp_value_for_v_model
                situation: `000`,

                // 选择模式
                // multiple：多选
                // single：单选
                select_mode: `multiple`,

                entity_define: {
                    property_name_for_id: `id`,
                    property_name_for_name: `name`,
                    get_enable(pParameter) {
                        if (!pParameter) pParameter = {};
                        const entity = pParameter.entity;
                        return true;
                    },
                },

                table: {
                    column_list: [
                        {
                            prop: `id`,
                            label: `id`,
                            width: `40`,
                        },
                        {
                            prop: `name`,
                            label: `姓名`,
                            width: `70`,
                        },
                        {
                            prop: `phone`,
                            label: `联系方式`,
                            width: ``,
                        },
                    ],
                },

                get_params() {
                    return Q.resolve({});
                },

                get_data_source(pParameter) {
                    if (!pParameter) pParameter = {};
                    const params = pParameter.params;

                    const all_entity_list = [];
                    return Q.resolve({
                        all_entity_list,
                    });
                },

                btn_ok_click_event_handler() {
                    console.log(`__btn_ok_click_event_handler`);
                },

                btn_cancel_click_event_handler() {
                    console.log(`__btn_cancel_click_event_handler`);
                },
            },

        };
    },

    computed: {

        available_value_for_v_model() {
            const __this = this;

            //entity_define
            const property_name_for_id = __this.init_parameter.entity_define.property_name_for_id;
            const property_name_for_name = __this.init_parameter.entity_define.property_name_for_name;

            const situation = __this.init_parameter.situation;

            const temp_value_for_v_model = __this.temp_value_for_v_model;

            const value_for_v_model = __this.value_for_v_model;

            const all_entity_list = __this.data_get_data_source.all_entity_list;

            let id_list;
            if (situation === `000`) {
                id_list = value_for_v_model;
            } else {
                id_list = temp_value_for_v_model;
            }
            return id_list;
        },

        left_entity_list() {
            const __this = this;
            const all_entity_list = __this.data_get_data_source.all_entity_list;
            const key = __this.left_input.value.trim().toLowerCase();
            const entity_list = _.chain(all_entity_list)
                .filter(function (m) {
                    const json = JSON.stringify(m).toLowerCase();
                    return json.indexOf(key) > -1;
                })
                .value()
            ;

            return entity_list;
        },

        right_entity_list() {
            const __this = this;

            //entity_define
            const property_name_for_id = __this.init_parameter.entity_define.property_name_for_id;
            const property_name_for_name = __this.init_parameter.entity_define.property_name_for_name;

            const all_entity_list = __this.data_get_data_source.all_entity_list;

            const id_list = __this.available_value_for_v_model;

            const right_input = __this.right_input;
            const key = right_input.value.trim().toLowerCase();
            const entity_list = _.chain(all_entity_list)
                .filter(function (m) {
                    const id = m[property_name_for_id];
                    const json = JSON.stringify(m).toLowerCase();
                    return 1 === 1
                        && _.contains(id_list, id)
                        && json.indexOf(key) > -1
                        ;
                })
                .value()
            ;
            return entity_list;
        },

        all_loading() {
            const __this = this;
            if (__this.left_card.loading || __this.right_card.loading) {
                return true;
            }
            return false;
        },
    },

    watch: {
        value: {
            handler(pNewValue, pOldValue) {
                const __this = this;
                __this.value_for_v_model = pNewValue;

                const situation = __this.init_parameter.situation;
                if (situation === `100`) {
                    const temp_value_for_v_model = __this.temp_value_for_v_model;
                    if (temp_value_for_v_model.length > 0) {
                        temp_value_for_v_model.splice(0, temp_value_for_v_model.length);
                    }
                    _.each(pNewValue, function (m) {
                        temp_value_for_v_model.push(m);
                    })
                }
            },
            immediate: true,
            // deep: true,
            //参考：https://blog.csdn.net/Liu_yunzhao/article/details/95395427
        },

        value_for_v_model: {
            handler(pNewValue, pOldValue) {
                const __this = this;

                __this.$emit('input', pNewValue);

                // __this.__init_value_for_v_model({
                //     id_list: pNewValue,
                // })
            },
            // immediate: true,
            // deep: true,
            //参考：https://blog.csdn.net/Liu_yunzhao/article/details/95395427
        }
    },

    methods: {

        __get_entity_list_by_id_list(pParameter) {
            if (!pParameter) pParameter = {};

            const __this = this;

            const id_list = pParameter.id_list || [];

            //entity_define
            const property_name_for_id = __this.init_parameter.entity_define.property_name_for_id;
            const property_name_for_name = __this.init_parameter.entity_define.property_name_for_name;

            const all_entity_list = __this.data_get_data_source.all_entity_list;

            const entity_list = _.chain(all_entity_list)
                .filter(function (m) {
                    const id = m[property_name_for_id];
                    return _.contains(id_list, id);
                })
                .value()
            ;

            return entity_list;
        },

        __init_data_source() {
            const __this = this;

            //entity_define
            const property_name_for_id = __this.init_parameter.entity_define.property_name_for_id;
            const property_name_for_name = __this.init_parameter.entity_define.property_name_for_name;

            const get_params = __this.init_parameter.get_params;

            const get_data_source = __this.init_parameter.get_data_source;
            if (!_.isFunction(get_data_source)) {
                const msg = `__init_data_source parameter error, code=001`;
                console.error(msg);
                console.trace();
                return Q.reject({msg: msg});
            }

            return Q.when()
                .then(function () {
                    __this.left_card.loading = true;

                    let p = Q.resolve();
                    if (_.isFunction(get_params)) {
                        p = get_params();
                    }
                    return p;
                })
                .then(function (params) {
                    const fn = _.bind(get_data_source, __this);
                    return fn({
                        params,
                    });
                })
                .then(function (data) {
                    if (!data) {
                        const msg = '__init_data_source parameter error, code=002';
                        console.error(msg);
                        console.trace();
                        return Q.reject({msg: msg});
                    }

                    const all_entity_list = data.all_entity_list;
                    if (!_.isArray(all_entity_list)) {
                        const msg = '__init_data_source parameter error, code=003';
                        console.error(msg);
                        console.trace();
                        return Q.reject({msg: msg});
                    }
                    for (let i = 0; i < all_entity_list.length; i++) {
                        const entity = all_entity_list[i];
                        const id = entity[property_name_for_id];
                        if (!id) {
                            const msg = '__init_data_source parameter error, code=004';
                            console.error(msg);
                            console.trace();
                            return Q.reject({msg: msg});
                        }
                    }

                    __this.data_get_data_source.all_entity_list = all_entity_list;
                    __this.left_card.loading = false;
                    __this.data_get_data_source.defer.resolve();

                })
                .catch(function (ex) {
                    console.error(ex);
                    if (ex) {
                        if (ex.stack) {
                            console.error(ex.stack);
                        }
                    }
                    return Q.reject(ex);
                })
                ;

        },

        __left_btn_filter_click() {
            const __this = this;

            const key = __this.left_input.value.trim();
        },

        __left_btn_select_all_click() {
            const __this = this;

            const __left_table_entity_operate = __this.__left_table_entity_operate;
            const entity_list = __this.left_entity_list;

            _.each(entity_list, function (entity) {
                __left_table_entity_operate({
                    entity,
                    type: `selected`,
                });
            })

        },

        __left_btn_unselect_all_click() {
            const __this = this;

            const __left_table_entity_operate = __this.__left_table_entity_operate;
            const entity_list = __this.left_entity_list;

            _.each(entity_list, function (entity) {
                __left_table_entity_operate({
                    entity,
                    type: `unselected`,
                });
            })
        },

        __left_input_keyup_event_handler(pKeyboardEvent) {
            const __this = this;
            const key = pKeyboardEvent.key;
            if (key === `Enter`) {
                __this.__left_btn_filter_click();
            }
        },

        __left_input_clear_event_handler() {
            const __this = this;
            __this.__left_btn_filter_click();
        },

        __left_table_entity_operate(pParameter) {
            const __this = this;

            if (!pParameter) pParameter = {};
            const entity = pParameter.entity;
            const type = pParameter.type || `toggle`;//toggle||selected||unselected

            //entity_define
            const property_name_for_id = __this.init_parameter.entity_define.property_name_for_id;
            const property_name_for_name = __this.init_parameter.entity_define.property_name_for_name;

            const __left_table_entity_get_enable = __this.__left_table_entity_get_enable;

            const enable = __left_table_entity_get_enable({
                entity,
            });
            if (!enable) {
                return;
            }

            const situation = __this.init_parameter.situation;

            const select_mode = __this.init_parameter.select_mode;

            const temp_value_for_v_model = __this.temp_value_for_v_model;
            const value_for_v_model = __this.value_for_v_model;

            const available_value_for_v_model = __this.available_value_for_v_model;

            const id = entity[property_name_for_id];

            const process_select_mode_single = function () {
                if (temp_value_for_v_model.length > 0) {
                    temp_value_for_v_model.splice(0, temp_value_for_v_model.length);
                }
                temp_value_for_v_model.push(id);

                if (situation === `000`) {
                    if (value_for_v_model.length > 0) {
                        value_for_v_model.splice(0, value_for_v_model.length);
                    }
                    value_for_v_model.push(id);
                }
            };

            const process_select_mode_multiple = function () {
                const id_list = available_value_for_v_model;

                const index_from_id_list = _.findIndex(id_list, function (m) {
                    return m === id;
                });

                const is_can_remove = (index_from_id_list > -1);
                const is_can_add = !is_can_remove;
                const is_selected = is_can_remove;

                //设置为选中
                //即执行添加操作
                const process_select_mode_multiple_type_selected = function () {
                    //这个判断只是为了进行一步地检验非法数据
                    if (!is_can_add) return;

                    //当前点击的id不在已选的id里
                    //执行添加操作
                    temp_value_for_v_model.push(id);

                    if (situation === `000`) {
                        value_for_v_model.push(id);
                    }
                };

                //设置为不选中
                //即执行删除操作
                const process_select_mode_multiple_type_unselected = function () {
                    //这个判断只是为了进行一步地检验非法数据
                    if (!is_can_remove) return;

                    temp_value_for_v_model.splice(index_from_id_list, 1);

                    if (situation === `000`) {
                        value_for_v_model.splice(index_from_id_list, 1);
                    }
                };

                //执行转换操作
                const process_select_mode_multiple_type_toggle = function () {
                    //当前点击的id在已选的id里
                    //执行删除操作
                    if (is_selected) {
                        return process_select_mode_multiple_type_unselected();
                    }

                    //当前点击的id不在已选的id里
                    //执行添加操作
                    return process_select_mode_multiple_type_selected();

                };

                if (type === `selected`) return process_select_mode_multiple_type_selected();
                if (type === `unselected`) return process_select_mode_multiple_type_unselected();
                return process_select_mode_multiple_type_toggle();
            };

            if (select_mode === `single`) return process_select_mode_single();
            process_select_mode_multiple();
        },

        __left_table_entity_get_enable(pParameter) {
            const __this = this;

            if (!pParameter) pParameter = {};
            const entity = pParameter.entity;

            //entity_define
            const property_name_for_id = __this.init_parameter.entity_define.property_name_for_id;
            const property_name_for_name = __this.init_parameter.entity_define.property_name_for_name;
            const get_enable = __this.init_parameter.entity_define.get_enable;

            let enable = true;
            if (_.isFunction(get_enable)) {
                enable = get_enable({
                    entity,
                });
            }
            return enable;
        },

        __left_table_row_click_event_handler(row) {
            const __this = this;

            const __left_table_entity_operate = __this.__left_table_entity_operate;
            __left_table_entity_operate({
                entity: row,
                type: `toggle`,
            });
        },

        __left_table_init_row_class_name({row, rowIndex}) {
            const __this = this;

            //entity_define
            const property_name_for_id = __this.init_parameter.entity_define.property_name_for_id;
            const property_name_for_name = __this.init_parameter.entity_define.property_name_for_name;

            const available_value_for_v_model = __this.available_value_for_v_model;

            const __left_table_entity_get_enable = __this.__left_table_entity_get_enable;

            const id_list = available_value_for_v_model;

            const entity = row;
            const id = entity[property_name_for_id];

            let s = ``;
            if (_.contains(id_list, id)) {
                s += ' row-entity-selected';
            }

            const enable = __left_table_entity_get_enable({
                entity,
            });
            if (!enable) {
                s += ' row-entity-disabled';
            }
            return s;
        },

        __right_btn_filter_click() {
            const __this = this;

            const key = __this.left_input.value;
        },

        __right_btn_remove_entity_click(pEntity) {
            const __this = this;

            const __left_table_entity_operate = __this.__left_table_entity_operate;
            __left_table_entity_operate({
                entity: pEntity,
                type: `unselected`,
            });
        },

        __right_input_keyup_event_handler(pKeyboardEvent) {
            // const __this = this;
            // const key = pKeyboardEvent.key;
            // if (key === `Enter`) {
            // }
        },

        //--------------------------------------------------------------------------------------------------------------

        get_selected_entity_list(pParameter) {
            const __this = this;

            if (!pParameter) pParameter = {};

            const __id_list = pParameter.id_list;

            const available_value_for_v_model = __this.available_value_for_v_model;
            const __get_entity_list_by_id_list = __this.__get_entity_list_by_id_list;

            let id_list;
            if (_.isArray(__id_list)) {
                id_list = __id_list;
            } else {
                id_list = available_value_for_v_model;
            }

            return __get_entity_list_by_id_list({
                id_list,
            });
        },

        get_selected_entity(pParameter) {
            const __this = this;

            if (!pParameter) pParameter = {};
            const __id_list = pParameter.id_list;
            const __id = pParameter.id;

            let id_list;
            if (_.isArray(__id_list)) {
                id_list = __id_list;
            } else if (__id) {
                id_list = [
                    __id,
                ];
            } else {
                id_list = null;
            }

            const get_selected_entity_list = __this.get_selected_entity_list;
            const entity_list = get_selected_entity_list({
                id_list,
            });
            let entity = null;
            if (entity_list.length > 0) {
                entity = entity_list[0];
            }
            return entity;
        },

        get_selected_entity_list_promise(pParameter) {
            const __this = this;

            if (!pParameter) pParameter = {};

            const get_selected_entity_list = __this.get_selected_entity_list;
            const entity_list = get_selected_entity_list(pParameter);
            return Q.resolve({
                entity_list,
            });
        },

        get_selected_entity_promise(pParameter) {
            const __this = this;

            if (!pParameter) pParameter = {};

            const get_selected_entity = __this.get_selected_entity;
            const entity = get_selected_entity(pParameter);
            return Q.resolve({
                entity,
            });
        },

        init(pInitParameter) {
            const __this = this;

            if (!pInitParameter) pInitParameter = {};

            const default_init_parameter = {};
            default_init_parameter.get_data_source = null;

            extend(__this.init_parameter, default_init_parameter, pInitParameter);
            extend(__this.init_parameter.entity_define, default_init_parameter.entity_define, pInitParameter.entity_define);

            __this.left_input.value = ``;
            __this.right_input.value = ``;
            __this.__init_data_source();
        },

    },

    mounted() {
        const __this = this;
        const enableAutoInit = __this.enableAutoInit;
        if (enableAutoInit) __this.init();
    }
};
